// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BrandsResellersRouteImport } from './routes/brands-resellers'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DoNotSellRouteImport } from './routes/do-not-sell'
import { Route as DropshippingRouteImport } from './routes/dropshipping'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as OpticiansRouteImport } from './routes/opticians'
import { Route as PharmacyRouteImport } from './routes/pharmacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UpdatesRouteImport } from './routes/updates'
import { Route as VirtualTryOnRouteImport } from './routes/virtual-try-on'
import { Route as WizardConsumerTermsRouteImport } from './routes/wizard-consumer-terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminMediaRouteImport } from './routes/admin/media'
import { Route as AdminPagesRouteImport } from './routes/admin/pages'
import { Route as AdminPostsRouteImport } from './routes/admin/posts'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminPagesSlugRouteImport } from './routes/admin/pages.$slug'
import { Route as AdminPostsIdRouteImport } from './routes/admin/posts.$id'
import { Route as AdminPostsNewRouteImport } from './routes/admin/posts.new'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const BrandsResellersRoute = BrandsResellersRouteImport.update({
            id: '/brands-resellers',path: '/brands-resellers',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const DoNotSellRoute = DoNotSellRouteImport.update({
            id: '/do-not-sell',path: '/do-not-sell',getParentRoute: () => rootRouteImport
          })
const DropshippingRoute = DropshippingRouteImport.update({
            id: '/dropshipping',path: '/dropshipping',getParentRoute: () => rootRouteImport
          })
const LaunchRoute = LaunchRouteImport.update({
            id: '/launch',path: '/launch',getParentRoute: () => rootRouteImport
          })
const OpticiansRoute = OpticiansRouteImport.update({
            id: '/opticians',path: '/opticians',getParentRoute: () => rootRouteImport
          })
const PharmacyRoute = PharmacyRouteImport.update({
            id: '/pharmacy',path: '/pharmacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const UpdatesRoute = UpdatesRouteImport.update({
            id: '/updates',path: '/updates',getParentRoute: () => rootRouteImport
          })
const VirtualTryOnRoute = VirtualTryOnRouteImport.update({
            id: '/virtual-try-on',path: '/virtual-try-on',getParentRoute: () => rootRouteImport
          })
const WizardConsumerTermsRoute = WizardConsumerTermsRouteImport.update({
            id: '/wizard-consumer-terms',path: '/wizard-consumer-terms',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          })
const AdminMediaRoute = AdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AdminRoute
          })
const AdminPagesRoute = AdminPagesRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => AdminRoute
          })
const AdminPostsRoute = AdminPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => AdminRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AdminPagesSlugRoute = AdminPagesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AdminPagesRoute
          })
const AdminPostsIdRoute = AdminPostsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPostsRoute
          })
const AdminPostsNewRoute = AdminPostsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminPostsRoute
          })





const AdminPagesRouteChildren = {
  AdminPagesSlugRoute: AdminPagesSlugRoute
}

const AdminPagesRouteWithChildren = AdminPagesRoute._addFileChildren(AdminPagesRouteChildren)




const AdminPostsRouteChildren = {
  AdminPostsIdRoute: AdminPostsIdRoute,AdminPostsNewRoute: AdminPostsNewRoute
}

const AdminPostsRouteWithChildren = AdminPostsRoute._addFileChildren(AdminPostsRouteChildren)



const AdminRouteChildren = {
  AdminLoginRoute: AdminLoginRoute,AdminMediaRoute: AdminMediaRoute,AdminPagesRoute: AdminPagesRouteWithChildren,AdminPostsRoute: AdminPostsRouteWithChildren,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,BrandsResellersRoute: BrandsResellersRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,DemoRoute: DemoRoute,DoNotSellRoute: DoNotSellRoute,DropshippingRoute: DropshippingRoute,LaunchRoute: LaunchRoute,OpticiansRoute: OpticiansRoute,PharmacyRoute: PharmacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsOfUseRoute: TermsOfUseRoute,UnsubscribeRoute: UnsubscribeRoute,UpdatesRoute: UpdatesRoute,VirtualTryOnRoute: VirtualTryOnRoute,WizardConsumerTermsRoute: WizardConsumerTermsRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)